import { css, styled } from 'styled-components';

import { Media } from '../../../theme/Media.tsx';
import { CONTAINER_MAX_WIDTH_CSS, CONTAINER_PADDING_SM_MAX_CSS, CONTAINER_PADDING_SM_MIN_CSS } from './constants.ts';
import { getGridLayoutStyles } from './gridStyles.ts';
import type { ContainerLayout } from './types.ts';

export const StyledContainer = styled.div<{ $fluid?: boolean; $layout?: ContainerLayout; $spacer?: boolean }>`
  width: 100%;
  box-sizing: border-box;

  @media ${Media.smMin} {
    padding: 0 ${CONTAINER_PADDING_SM_MIN_CSS};
  }

  @media ${Media.xsMax} {
    padding: 0 ${CONTAINER_PADDING_SM_MAX_CSS};
  }

  ${({ $spacer }) =>
    $spacer &&
    css`
      margin-bottom: 24px;
    `}

  ${({ $fluid }) =>
    !$fluid &&
    css`
      max-width: ${CONTAINER_MAX_WIDTH_CSS};
      margin-left: auto;
      margin-right: auto;
    `}

  ${({ $layout }) =>
    $layout !== undefined &&
    css`
      display: grid;
      align-items: flex-start;
      ${getGridLayoutStyles($layout)}

      > * {
        min-width: 0;
      }
    `}
`;
